export const adminAccess = [
  "ADMIN_MENSALISTA",
  "ADMIN_VEICULO",
  "ADMIN_CARTAO",
  "ADMIN_CAIXA",
  "ADMIN_USUARIO",
  "ADMIN_CONTRATO",
  "ADMIN_VEICULO_MODELO",
  "ADMIN_UNIDADE",
  "ADMIN_ENTRADA",
  "ADMIN_DESPESA_RECEITA",
  "ADMIN_PARAMETRO",
  "ADMIN_CLIENTE",
  "ADMIN_VAGA",
  "ADMIN_PAGAMENTO",
  "ADMIN_EMPRESA",
  "ADMIN_CONTA_BANCARIA",
  "ADMIN_TROCA_UNIDADE",
];
